import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import $ from 'jquery';
import './partials/components/component-example/component-example.js';
var ExampleFeature = /*#__PURE__*/_createClass(function ExampleFeature() {
  _classCallCheck(this, ExampleFeature);
});
new ExampleFeature();